import React from "react";
import EmailIcon from "@/components/icons/Email";

interface SupportSectionProps {
  className?: string;
}

const SupportSection: React.FC<SupportSectionProps> = ({ className = "flex flex-col gap-y-4 mt-8 text-start items-start w-[475px] max-xl:w-[375px]" }) => {
  return (
    <div className={className}>
      <span className="text-[#4E4E4E] text-xs">Need support?</span>
      <span className="text-[#4E4E4E] text-xs flex gap-1">
        Email us at{" "}
        <a
          href="mailto:info@gteconnects.com"
          className="flex items-center gap-1 text-[#4E4E4E] hover:underline"
        >
          <EmailIcon color="#4E4E4E" /> info@gteconnects.com
        </a>
      </span>
    </div>
  );
};

export default SupportSection;
